import { render, staticRenderFns } from "./FilterSelector.vue?vue&type=template&id=8384aa06&scoped=true&lang=pug"
import script from "./FilterSelector.vue?vue&type=script&lang=ts"
export * from "./FilterSelector.vue?vue&type=script&lang=ts"
import style0 from "./FilterSelector.vue?vue&type=style&index=0&id=8384aa06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8384aa06",
  null
  
)

export default component.exports